// extracted by mini-css-extract-plugin
module.exports = {"page":"qG-z","cartModal":"rG-z","checkout":"sG-z","placeholder":"tG-z","account":"uG-z"};